// extracted by mini-css-extract-plugin
export default {"container":"FiltersGroupContainer_container__GmjWv"};